module.exports = __webpack_public_path__ + "static/dairy-cow-e3aeeb78b2056d3c1ef40e6b27767846.svg";